import Lara from '@primeuix/themes/lara';
import { definePreset } from '@primeuix/themes';

const MedmasteryLaraPreset = definePreset(Lara, {
  semantic: {
    primary: {
      50: '#e6f7ff',
      100: '#E3F4FC',
      200: '#B6E4FB',
      300: '#7FD0FA',
      400: '#58BEF3',
      500: '#3AA7DF',
      600: '#168ECC',
      700: '#0E7FB9',
      800: '#086CA0',
      900: '#04608F',
      950: '#00476B',
    },
  },
});

export default MedmasteryLaraPreset;